import React from 'react';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import {StackParamList} from '../../../../../navigators';
import {SuccessTemplate} from '../../../../../components/templates/success';
import {
  PrimaryButton,
  SecondaryButton,
} from '../../../../../components/buttons';
import {message} from '../../../../../utils/messages';

type ScreenProps = NativeStackScreenProps<
  StackParamList,
  'FeePaymentProofSuccessScreen'
>;

export const FeePaymentProofSuccessScreen = ({navigation}: ScreenProps) => {
  const handlePrimaryPress = async () => {
    navigation.reset({
      index: 0,
      routes: [{name: 'Dashboard'}],
    });
  };

  const handleSecondaryPress = () => {
    navigation.reset({
      index: 0,
      routes: [{name: 'UnpaidedBillListScreen'}],
    });
  };

  return (
    <SuccessTemplate
      title={message('proof-success-title')}
      summary={message('proof-success-summary')}>
      <PrimaryButton
        label={message('fee-payment-proof-success-primary-button')}
        onPress={() => handlePrimaryPress()}
      />
      <SecondaryButton
        label={message('fee-payment-proof-success--secondary-button')}
        mt="5"
        onPress={() => handleSecondaryPress()}
      />
    </SuccessTemplate>
  );
};
